<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 100%;
  font-family: Microsoft YaHei, "Helvetica Neue", Arial, sans-serif;
}
#app {
  height: 100%;
  display: flex;
}

input {
  border: none;
  outline: none;
  background: transparent;
}

.single-line {
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal !important;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

</style>



// WEBPACK FOOTER //
// src/rczk/App.vue